import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import WebStorageCache from 'web-storage-cache';
var wsCache = new WebStorageCache({
  storage: 'localStorage',
  exp: Infinity
});

// 过期时间为12个小时：这里使用的秒
var myExp = 12 * 60 * 60;
// var myExp = 20;

export default new Vuex.Store({
  state: {
    userInfo: null,
    userInfo02: null,
    groundMarketingInfo: null
  },
  mutations: {
    LONIN_SET(state, info) {
      state.userInfo = info;
      window.localStorage.setItem('luckyDraw_UserInfo', JSON.stringify(info)); 
    },
    LONIN_SET02(state, info) {
      state.userInfo02 = info;
      window.localStorage.setItem('luckyDraw_UserInfo02', JSON.stringify(info)); 
    },
    
    LOGOUT(state) {
      state.userInfo = null;
      // window.localStorage.removeItem('luckyDraw_UserInfo');
    }, 

    LOGOUT02(state) {
      state.userInfo02 = null;
      // window.localStorage.removeItem('luckyDraw_UserInfo02');
    },

    // 针对新的落地营销：
    SET_GroundMarketingInfo(state, info) {
      state.groundMarketingInfo = info;
      // window.localStorage.setItem('luckyDraw_GroundMarketingInfo', JSON.stringify(info));
      wsCache.set('luckyDraw_GroundMarketingInfo', JSON.stringify(info), {exp: myExp});
    },

    Remove_GroundMarketingInfo(state) {
      state.groundMarketingInfo = null;
      // window.localStorage.removeItem('luckyDraw_GroundMarketingInfo');
      wsCache.delete('luckyDraw_GroundMarketingInfo');
    }
  },
  getters: {
    getInfo: function(state) {
      let uInfo = state.userInfo;
      if (!uInfo) {
        uInfo =  window.localStorage.getItem('luckyDraw_UserInfo') && JSON.parse(window.localStorage.getItem('luckyDraw_UserInfo'))
      }
      if (uInfo === null) {
        window.localStorage.removeItem('luckyDraw_UserInfo');
       return; 
      }
      return uInfo;
    },
    getInfo02: function(state) {
      let uInfo = state.userInfo02;
      if (!uInfo) {
        uInfo =  window.localStorage.getItem('luckyDraw_UserInfo02') && JSON.parse(window.localStorage.getItem('luckyDraw_UserInfo02'))
      }
      if (uInfo === null) {
        window.localStorage.removeItem('luckyDraw_UserInfo02');
       return; 
      }
      return uInfo;
    },
    // 落地营销：
    getGroundMarketingInfo: function(state) {
      let uInfo = state.groundMarketingInfo;
      if (!uInfo) {
        // uInfo =  window.localStorage.getItem('luckyDraw_GroundMarketingInfo') && JSON.parse(window.localStorage.getItem('luckyDraw_GroundMarketingInfo'))
        uInfo =  wsCache.get('luckyDraw_GroundMarketingInfo') && JSON.parse(wsCache.get('luckyDraw_GroundMarketingInfo'))
      }
      if (uInfo === null) {
        // window.localStorage.removeItem('luckyDraw_GroundMarketingInfo');
        wsCache.delete('luckyDraw_GroundMarketingInfo');
       return; 
      }
      return uInfo;
    },

  },
  actions: {

  }
})
